import { useState } from "react";
import { AlertCircle, CheckCircle2, ChevronDown } from "lucide-react";

const TAB_NO = { client: 1, financial: 2, investment: 3, insurance: 4 };

export const MissingBar = ({ list, onJump }) => {
  const [open, setOpen] = useState(false);
  if (!list.length) return (
    <div className="mt-2 flex items-center gap-1.5 text-xs font-medium text-emerald-700" data-testid="required-complete">
      <CheckCircle2 className="h-4 w-4" /> All required fields entered. Calculations are complete.
    </div>
  );
  return (
    <div className={`missing-bar ${open ? "is-open" : ""}`} data-testid="missing-fields-bar">
      <button type="button" className="missing-toggle" onClick={() => setOpen((o) => !o)} data-testid="missing-toggle-button" aria-expanded={open}>
        <AlertCircle className="h-4 w-4 shrink-0" />
        <span className="font-semibold missing-title-long">Enter to complete the calculations:</span>
        <span className="font-semibold missing-title-short">{list.length} item{list.length > 1 ? "s" : ""} needed to finish</span>
        <ChevronDown className="h-4 w-4 missing-chevron" />
      </button>
      {list.map((m) => (
        <button key={m.target} type="button" className="missing-chip" onClick={() => { setOpen(false); onJump(m); }} data-testid={`missing-${m.target}`}>
          {m.label} <span className="text-amber-600 font-normal">· Tab {TAB_NO[m.tab]}</span>
        </button>
      ))}
    </div>
  );
};
